import React, { forwardRef, ReactNode } from 'react';
import Tooltip from 'rc-tooltip';
import { mouseEnterDelay } from 'components/feature/Report/ReportSidebar/common/constants';
import { TooltipPlacement } from 'core/constants/report';
import StyledSecondaryButton from './secondary-button.style';
import useLocalize from '../Localization/useLocalize.hook';

interface ISecondaryButtonProps {
  onClickHandler: () => void;
  displayName?:ReactNode;
  classNames?: Array<string>;
  wrapperClassName?: Array<string>;
  uniqueKey: string;
  isDisable?: boolean;
  tooltip?:string;
  tooltipPlacement?:string;
  tooltipOverlayClass?:string;
}

const SecondaryButton = forwardRef((props: ISecondaryButtonProps, ref: any) => {
  const {
    onClickHandler,
    classNames,
    displayName,
    uniqueKey,
    wrapperClassName,
    isDisable,
    tooltip,
    tooltipPlacement,
    tooltipOverlayClass,
  } = props;

  return (
    <StyledSecondaryButton
      key={uniqueKey}
      className={`${wrapperClassName.join(' ')}`}
    >
      <Tooltip
        placement={tooltipPlacement}
        overlay={<span style={{ whiteSpace: 'nowrap' }}>{tooltip || displayName}</span>}
        mouseEnterDelay={mouseEnterDelay}
        overlayClassName={`se-dark-theme-tooltip ${tooltipOverlayClass}`}
      >
        <button
          type="button"
          ref={ref}
          className={`se-secondary-changes ${
            isDisable ? 'se-button-disabled' : ''
          } ${classNames.join(' ')}`}
          onClick={() => !isDisable && onClickHandler()}
        >
          {displayName}
        </button>
      </Tooltip>
    </StyledSecondaryButton>
  );
});

SecondaryButton.defaultProps = {
  classNames: [],
  wrapperClassName: [],
  displayName: `${useLocalize('cmn.cancel')}`,
  isDisable: false,
  tooltip: '',
  tooltipPlacement: TooltipPlacement.Left,
};

export default SecondaryButton;
